module.exports = __webpack_public_path__ + "media/img/auth/brain-9e5a830ad66a6797a819f9e2cc3db7f7.png";